var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.139,
    height: 21.778,
    viewBox: "0 0 21.139 21.778",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calendar_with_interaction",
    "data-name": "Calendar with interaction",
    transform: "translate(0.25 0.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2103",
    "data-name": "Path 2103",
    d: "M197.32,105.2h-2.975v-.786a.587.587,0,0,0-1.173,0v.786h-7.448v-.786a.587.587,0,0,0-1.173,0v.786h-2.975a2.449,2.449,0,0,0-2.447,2.447v15.012a2.449,2.449,0,0,0,2.447,2.447H197.32a2.449,2.449,0,0,0,2.447-2.447V107.642a2.449,2.449,0,0,0-2.447-2.447ZM180.3,107.642a1.275,1.275,0,0,1,1.274-1.273h2.975v.786a.587.587,0,0,0,1.173,0v-.786h7.448v.786h0a.587.587,0,0,0,1.173,0v-.786h2.975a1.275,1.275,0,0,1,1.274,1.273v3.542H180.3Zm17.018,16.288H181.576a1.275,1.275,0,0,1-1.274-1.276v-10.3h18.292v10.3a1.275,1.275,0,0,1-1.274,1.276Z",
    transform: "translate(-179.129 -103.823)",
    fill: "#a5a5a5",
    stroke: "#a5a5a5",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarGray);
export default __webpack_public_path__ + "static/media/CalendarGray.b6d26ae8c506e30358c9944c13e1d988.svg";
export { ForwardRef as ReactComponent };